<template>
  <span
    v-if="status"
    :class="[boxClass, 'flex items-center justify-center flex-shrink-0']"
    :title="tooltip"
  >
    <!-- In a match — the nav item routes to the matchroom, this is the affordance -->
    <PlayIcon v-if="status === 'in_match'" :class="[sizeClass, 'text-green-400']" />
    <!-- Searching — same spinner the queue panel uses -->
    <svg
      v-else
      :class="[sizeClass, 'text-primary-400 animate-spin']"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
    </svg>
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { PlayIcon } from '@heroicons/vue/24/solid';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  // "searching" | "in_match" | null — owned by the sidebar, which already keeps
  // the party/lobby state live over the MatchmakingChannel on every page.
  status: {
    type: String,
    default: null,
  },
  // Sits over the nav icon in the collapsed (icons-only) sidebar.
  compact: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const sizeClass = computed(() => (props.compact ? 'h-3 w-3' : 'h-4 w-4'));

// In the sidebar this takes the slot of the "Beta" pill, which is 22px tall
// (10px text inheriting the row's 20px line-height, plus its py-[1px]). Match
// that height so swapping the two does not resize the row and nudge every nav
// item under it. The compact badge is absolutely positioned, so it stays free.
const boxClass = computed(() => (props.compact ? '' : 'h-[22px]'));

const tooltip = computed(() => {
  if (props.status === 'in_match') return t('play.matchmaking.in_match_tooltip');
  return t('play.matchmaking.searching_tooltip');
});
</script>
